import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IVaultTeam, IVaultConference } from './interfaces';

const basePath = '/teams';

/* eslint-disable implicit-arrow-linebreak */

export const getConferences = (sport?: string): AxiosPromise<IApiResponse<Array<IVaultConference>>> =>
  vaultApi.getInstance().get(basePath, {
    params: {
      teamType: 'conf',
      vendorSport: sport,
    },
  });

export const getTeams = (sport?: string): AxiosPromise<IApiResponse<Array<IVaultTeam>>> =>
  vaultApi.getInstance().get(basePath, {
    params: {
      teamType: 'team',
      vendorSport: sport,
    },
  });

export const getAllTeams = (vendorSport?: string): AxiosPromise<IApiResponse<Array<IVaultTeam>>> =>
  vaultApi.getInstance().get(basePath, {
    params: {
      vendorSport,
    },
  });
export const getAllTeamsBySport = (sport?: string, league?: string): AxiosPromise<IApiResponse<Array<IVaultTeam>>> => {
  // No sport and no league
  if (!sport && !league) return vaultApi.getInstance().get(basePath);

  // Build params object based on provided arguments
  const params: Record<string, string> = {};
  if (sport) params.teamSport = sport;
  if (league) params.teamLeague = league;

  return vaultApi.getInstance().get(basePath, { params });
};
export const getAllTimeoutTeams = (): AxiosPromise<IApiResponse<Array<IVaultTeam>>> => vaultApi.getInstance().get(`${basePath}/exchange/timeout`);

export const getTeamById = (teamId: string): AxiosPromise<IApiResponse<IVaultTeam>> =>
  vaultApi.getInstance().get(`${basePath}/${teamId}`);
